import * as Yup from 'yup';

const AutoWithdrawSchema = Yup.object().shape({
    amount: Yup.number()
        .required('حداقل مبلغ الزامی است')
        .typeError('مقدار وارد شده باید یک عدد باشد')
        .integer('مقدار وارد شده باید یک عدد باشد')
        .min(5000, 'حداقل مبلغ باید 5,000 ریال باشد')
        .max(100000000, 'حداقل مبلغ باید 100,000,000 ریال باشد')
        .transform((value, originalValue) =>
            originalValue === '' ? undefined : value,
        ),

    period: Yup.string().required('لطفا دوره مورد نظر را انتخاب نمایید'),

    bank_account: Yup.string()
        .required('وارد کردن حساب بانکی الزامی است')
        .length(26, 'فیلد حساب بانکی باید دقیقاً 26 کاراکتر با احتساب IR باشد')
        .test('is-valid-iran-iban', 'حساب بانکی معتبر نیست', (value) => {
            if (!value) return false;
            const iranIbanRegex = /^IR[0-9]{24}$/;
            return iranIbanRegex.test(value);
        }),

    partners: Yup.array().of(
        Yup.object().shape({
            iban: Yup.string().required(
                'حساب بانکی و مقدار تقسیم را به صورت درصدی یا ریالی وارد نمایید',
            ),

            amount: Yup.string().required(
                'حساب بانکی و مقدار تقسیم را به صورت درصدی یا ریالی وارد نمایید',
            ),
        }),
    ),
});

export default AutoWithdrawSchema;
